(() => {
  const buttons = () => document.querySelectorAll('[data-mw-stkt-cookie-settings]');
  const banner = () => window.privacyBanner;
  const update = () => {
    const available = typeof banner()?.showPreferences === 'function';
    buttons().forEach((button) => { button.hidden = !available; });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mw-stkt-cookie-settings]');
    if (!button || typeof banner()?.showPreferences !== 'function') return;
    try {
      Promise.resolve(banner().showPreferences()).catch(() => { button.hidden = true; });
    } catch (_) {
      button.hidden = true;
    }
  });

  update();
  window.addEventListener('load', update);
  window.addEventListener('pageshow', update);
  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('focusin', update);
  // The native banner can arrive asynchronously after the theme scripts.
  window.setTimeout(update, 1500);
  window.setTimeout(update, 5000);
})();
